export const formatDesignPdfFileName = ({
  title,
  wellName,
  designName,
}: {
  title: string;
  wellName?: string;
  designName?: string;
}) =>
  [title, wellName, designName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" - ");
